module.exports = __webpack_public_path__ + "media/IMG_0105.9e6de8ab.mp4";